import React, { useContext } from "react";
import ReactGA from 'react-ga4';
import { useFormik } from "formik";
import * as Yup from "yup";

// import { useGoogleLogin } from '@react-oauth/google';
import FacebookIcon from "../assets/images/facebook";
import GoogleIcon from "../assets/images/google";

import { TextField, Box, Button, Link, Divider, Alert, Typography, Backdrop } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';

import useApi from "../services/api";
import { AuthContext } from "../contexts/auth-context";
import { GlobalContext } from "../contexts/global-context";
import { useConfig } from "../contexts/config-context";
import { StandardLoading } from "./standard-loading";
import { useSocialAuth } from "../hooks/use-social-auth";
export function LoginForm() {
    const { setShowAuthModal, setAuthModalType, loginMessage } = useContext(GlobalContext);
    const { config } = useConfig();
    const { loginUser } = useApi();
    const { storeUser, setEmail, setSessionToken } = useContext(AuthContext);
    const { handleGoogleAuth, handleFacebookAuth, oauthLoading, generalError, setGeneralError } = useSocialAuth();

    // Remove old duplicate handlers - now using useSocialAuth hook
    /*
    const handleGoogleLogin = async () => {
        try {
            setOauthLoading(true);
            
            const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
            
            // Load Google Identity Services if not already loaded
            if (!window.google?.accounts?.id) {
                await new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = 'https://accounts.google.com/gsi/client';
                    script.onload = resolve;
                    script.onerror = reject;
                    document.head.appendChild(script);
                });
                
                // Wait a bit for the library to initialize
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            
            // Simple initialize and prompt approach
            window.google.accounts.id.initialize({
                client_id: clientId,
                callback: async (response) => {
                    try {
                        
                        if (!response.credential) {
                            throw new Error('No credential received');
                        }
                        
                        // Send ID token to backend
                        const userData = await loginWithProvider('google', response.credential, true);
                        
                        // Check for errors in new response format
                        if (userData.meta?.error === 'email_required') {
                            // User needs to provide email - don't store tokens yet
                            setSsoUserData({
                                user: userData.data?.user || userData.user,
                                provider: 'google',
                                sessionToken: userData.meta?.session_token
                            });
                            setAuthModalType("sso-email");
                        } else if (userData.meta?.error === 'email_not_verified') {
                            // User has email but needs to verify it
                            setEmail(userData.data?.user?.email || userData.user?.email);
                            setAuthModalType("emailed");
                        } else {
                            // Normal login with tokens
                            storeUser(userData);
                            setShowAuthModal(false);
                        }
                        setOauthLoading(false);
                    } catch (err) {
                        setOauthLoading(false);
                        setGeneralError({
                            isErrorHidden: false,
                            errorMessage: err.message || 'Authentication failed'
                        });
                    }
                },
                auto_select: false,
                cancel_on_tap_outside: true
            });
            
            // Try to prompt
            window.google.accounts.id.prompt((notification) => {
                if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
                    setOauthLoading(false);
                }
            });
            
        } catch (error) {
            setOauthLoading(false);
            setGeneralError({
                isErrorHidden: false,
                errorMessage: 'Failed to initialize Google Sign-In'
            });
        }
    };
    */

    /*
    const handleFacebookLogin = () => {
        const appId = process.env.REACT_APP_FACEBOOK_APP_ID;
        
        if (!appId) {
            setGeneralError({
                isErrorHidden: false,
                errorMessage: 'Facebook App ID not configured'
            });
            return;
        }
        
        setOauthLoading(true);
        
        // Initialize Facebook SDK using official pattern
        const initializeFacebookSDK = () => {
            window.fbAsyncInit = function() {
                window.FB.init({
                    appId: appId,
                    cookie: true,
                    xfbml: true,
                    version: 'v19.0'
                });
                
                // Now perform the login
                performFacebookLogin();
            };

            // Load SDK if not already loaded
            if (!document.getElementById('facebook-jssdk')) {
                const fjs = document.getElementsByTagName('script')[0];
                const js = document.createElement('script');
                js.id = 'facebook-jssdk';
                js.src = 'https://connect.facebook.net/en_US/sdk.js';
                fjs.parentNode.insertBefore(js, fjs);
            } else if (window.FB) {
                // SDK already loaded
                performFacebookLogin();
            }
        };
        
        const performFacebookLogin = () => {
            // Check if user is already connected
            window.FB.getLoginStatus(function(response) {
                if (response.status === 'connected') {
                    // Already connected, use existing token
                    handleFacebookResponse(response);
                } else {
                    // Need to login
                    window.FB.login(function(loginResponse) {
                        handleFacebookResponse(loginResponse);
                    }, { scope: 'email' });
                }
            });
        };
        
        const handleFacebookResponse = (response) => {
            if (response.status !== 'connected') {
                setOauthLoading(false);
                if (response.status === 'not_authorized') {
                    setGeneralError({
                        isErrorHidden: false,
                        errorMessage: 'Please authorize the app to continue'
                    });
                } else {
                    setGeneralError({
                        isErrorHidden: false,
                        errorMessage: 'Facebook login was cancelled'
                    });
                }
                return;
            }
            
            // Get the access token
            const accessToken = response.authResponse.accessToken;

            // Send access token to backend (async operation inside non-async callback)
            loginWithProvider('facebook', accessToken, true)
                .then((userData) => {
                    // Check for errors in new response format
                    if (userData.meta?.error === 'email_required') {
                        // User needs to provide email - don't store tokens yet
                        setSsoUserData({
                            user: userData.data?.user || userData.user,
                            provider: 'facebook',
                            sessionToken: userData.meta?.session_token
                        });
                        setAuthModalType("sso-email");
                    } else if (userData.meta?.error === 'email_not_verified') {
                        // User has email but needs to verify it
                        setEmail(userData.data?.user?.email || userData.user?.email);
                        setAuthModalType("emailed");
                    } else {
                        // Normal login with tokens
                        storeUser(userData);
                        setShowAuthModal(false);
                    }
                    setOauthLoading(false);
                })
                .catch((err) => {
                    setOauthLoading(false);
                    
                    // Extract detailed error message
                    let errorMessage = 'Facebook authentication failed';
                    if (err.response?.data?.errors) {
                        errorMessage = err.response.data.errors[0]?.message || errorMessage;
                    } else if (err.response?.data?.detail) {
                        errorMessage = err.response.data.detail;
                    } else if (err.response?.data?.error) {
                        errorMessage = err.response.data.error;
                    }
                    
                    setGeneralError({
                        isErrorHidden: false,
                        errorMessage: errorMessage
                    });
                });
        };
        
        // Start the initialization
        initializeFacebookSDK();
    };
    */

    const formik = useFormik({
        initialValues: {
            username: "",
            password: "",
        },
        validationSchema: Yup.object({
            username: Yup.string()
                .required("Required"),
            password: Yup.string()
                .required("Required"),
        }),
        onSubmit: values => {
            // clear any previously rendered errors
            setGeneralError({
                isErrorHidden: true,
                errorMessage: ""
            });

            loginUser(values)
                .then((response) => {
                    // status 200 => success
                    if (response.status === 200) {
                    ReactGA.event({ category: 'auth', action: 'login' });
                    storeUser(response.data);
                    setShowAuthModal(false);
                    }
                })
                .catch((error) => {
                    let errorMessage = 'Something went wrong. Please try again.';
                    
                    // Check for 401 with pending email verification flow
                    if (error.response?.status === 401 && error.response?.data?.data?.flows) {
                        const verifyEmailFlow = error.response.data.data.flows.find(flow => flow.id === 'verify_email');
                        if (verifyEmailFlow?.is_pending) {
                            setEmail(error.response.data.data.user?.email || values.username);
                            setSessionToken(error.response.data.meta?.session_token);
                            setAuthModalType("emailed");
                            formik.setSubmitting(false);
                            return;
                        }
                    }
                    // Handle new allauth error format
                    else if (error.response?.data?.errors && Array.isArray(error.response.data.errors)) {
                        // Extract the first error message from the errors array
                        const firstError = error.response.data.errors[0];
                        if (firstError?.message) {
                            errorMessage = firstError.message;
                        }
                    }
                    // Handle old format with detail field
                    else if (error.response?.data?.detail) {
                        errorMessage = error.response.data.detail;
                    }
                    // Handle network errors
                    else if (error.code === 'ERR_NETWORK') {
                        errorMessage = 'Network error. Please try again.';
                    }
                    
                    setGeneralError({
                        isErrorHidden: false,
                        errorMessage: errorMessage,
                    });
                    formik.setSubmitting(false);
                });
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    mt: 0,
                    m: 'auto'
                }}
                >
                    { !generalError.isErrorHidden ? (
                        <Alert sx={{mb: 1}} severity="error"> {generalError.errorMessage} </Alert>
                    ):null}
                    {loginMessage && (
                        <Typography
                            variant="body1"
                            color="textSecondary"
                            sx={{
                            mb: 2,
                            p: 2,
                            backgroundColor: (theme) =>
                                theme.palette.action.hover,
                            borderRadius: 1,
                            }}
                        >
                            {loginMessage}
                        </Typography>
                    )}
                    <TextField 
                        id="username" 
                        label="Email or Username" 
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.username}
                        disabled={formik.isSubmitting}
                        error={formik.touched.username && Boolean(formik.errors.username)}
                        helperText={formik.touched.username && formik.errors.username}
                        autoComplete="username"
                        />
                    <TextField 
                        type="password"
                        id="password" 
                        label="Password" 
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.password}
                        disabled={formik.isSubmitting}
                        error={formik.touched.password && Boolean(formik.errors.password)}
                        helperText={formik.touched.password && formik.errors.password}
                        autoComplete="current-password"
                        />
                    <LoadingButton
                        sx={{mt: 2}} 
                        variant="contained"
                        fullWidth
                        loading={formik.isSubmitting}
                        type="submit"
                        >
                            <span>Log in</span>
                    </LoadingButton>
                    <Link sx={{mt: 2}}
                        onClick={() => setAuthModalType("request-password-reset")} 
                        component="button">
                        Forgot password?
                    </Link>
                    
                    {/* Social Login Section - Only show if at least one SSO is enabled */}
                    {(config?.features?.sso?.google_enabled || config?.features?.sso?.facebook_enabled) && (
                        <>
                            <Divider sx={{m: 2}}>or</Divider>
                            
                            {config?.features?.sso?.google_enabled && (
                                <Button
                                    sx={{m: 1, color: 'text.primary' }}
                                    startIcon={<GoogleIcon />}
                                    variant="outlined"
                                    onClick={handleGoogleAuth}
                                >
                                    Continue with Google
                                </Button>
                            )}
                            
                            {config?.features?.sso?.facebook_enabled && (
                                <Button
                                    sx={{ m: 1, color: 'text.primary' }} 
                                    startIcon={<FacebookIcon />}
                                    variant="outlined"
                                    onClick={handleFacebookAuth}
                                >
                                    Continue with Facebook
                                </Button>
                            )}
                        </>
                    )}
                    <Box sx={{
                        mt: 2,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <span> Don&apos;t have an account?&nbsp;</span>
                        <Link
                            onClick={() => setAuthModalType("register")} 
                            component="button">
                            Sign up
                        </Link>
                    </Box>
                </Box>
            </form>
            
            {/* OAuth Loading Backdrop - matching site patterns */}
            <Backdrop
                sx={{ 
                    color: '#fff', 
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    position: 'absolute'
                }}
                open={oauthLoading}
            >
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    gap: 2
                }}>
                    <StandardLoading size={60} color='inherit' />
                    <Typography variant="h6" color="inherit">
                        Completing authentication...
                    </Typography>
                    <Typography variant="body2" color="inherit">
                        Please complete sign-in in the popup window
                    </Typography>
                </Box>
            </Backdrop>
        </>
    );
}
